export default __webpack_public_path__ + "static/media/mint-button-still.6ee8bd5b.gif";